export default "__VITE_ASSET__D_gMy5mM__"